import $ from "jquery";
import datepickerFactory from "jquery-datepicker";
import moment from "moment";
import "moment/locale/it";
import "./libs/bootstrap-init.js";

window.getClientRects = function () {
    return {top: 0, left: 0};
};

window.$ = window.jQuery = $;
registerSectionStepsSliderWithJquery($);
registerTestimonialsSliderWithJquery($);
window.moment = moment;
moment.locale("it");
datepickerFactory($);

// jquery-datepicker: richiesto da Evelean dashboard/tilemanager (articles.tilemanager.php → mainScript.js).
// Touchpoint frontend usa eonasdan datetimepicker, non jquery-datepicker.
// CSS è in main.scss → mainStyle.css (la pagina non carica mainScript.css).
require("eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");

import Swiper from "./libs/swiper-init.js";
import UXManager from "./libs/ux.js";
import LazyLoadManager from "./libs/lazyload.js";
import CountDownManager from "./libs/countdown.js";
import SwiperManager from "./libs/swiper.js";
import QRCodeManager from "./libs/qrcode.js";
import VideoControlsManager from "./libs/videocontrols.js";
import InvieportManager from "./libs/inviewport.js";
import GoogleMapsManager from "./libs/googlemaps.js";
import GoogleMapsAsideManager from "./libs/googlemapsaside.js";
import GeolocationManager from "./libs/geolocator.js";
import FAQManager from "./libs/faq.js";
import ModalizerManager from "./libs/modalizer.js";
import "./libs/section-searchbar.js";
import { initBannerHeroSprites } from "./libs/banner-hero-sprite.js";
import { initMappaDepositiMobileView } from "./libs/mappa-depositi-mobile-view.js";
import { initFormVariant } from "./libs/form-variant.js";
import {
    registerSectionStepsSliderWithJquery,
} from "./libs/section-steps-mobile-slider.js";
import { registerTestimonialsSliderWithJquery } from "./libs/testimonials-mobile-slider.js";
import { loadMoreArticles } from "./libs/loadMore.js";

$(document).ready(function () {
    const ux = new UXManager();
    window.ux = ux;
    initFormVariant();

    initBannerHeroSprites();
    initMappaDepositiMobileView();

    if (typeof window.__cfBindSectionStepsSlider === "function") {
        window.__cfBindSectionStepsSlider();
    }

    if (typeof window.__cfBindTestimonialsSlider === "function") {
        window.__cfBindTestimonialsSlider();
    }

    const mainNav = document.querySelector(".cf-main-nav");
    if (mainNav && !document.body.classList.contains("editing")) {
        const scrollThresholdPx = 60;
        const rootEl = document.documentElement;
        let scrollTicking = false;

        function syncMainNavScrollClass() {
            rootEl.classList.toggle(
                    "cf-main-nav-scrolled",
                    window.scrollY >= scrollThresholdPx
                    );
            scrollTicking = false;
        }

        function onMainNavScroll() {
            if (!scrollTicking) {
                window.requestAnimationFrame(syncMainNavScrollClass);
                scrollTicking = true;
            }
        }

        syncMainNavScrollClass();
        window.addEventListener("scroll", onMainNavScroll, {passive: true});

        const navToggle = mainNav.querySelector(".cf-main-nav__toggle");
        const navMenu = mainNav.querySelector("#cf-main-nav-menu");

        if (navToggle && navMenu) {
            const navToggleLabel = navToggle.querySelector(".visually-hidden");
            const navBackdrop = mainNav.querySelector(".cf-main-nav__backdrop");

            function setMainNavOpen(isOpen) {
                mainNav.classList.toggle("cf-main-nav--open", isOpen);
                rootEl.classList.toggle("cf-main-nav-menu-open", isOpen);
                navToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
                if (navToggleLabel) {
                    navToggleLabel.textContent = isOpen ? "Chiudi menu" : "Apri menu";
                }
            }

            navToggle.addEventListener("click", function () {
                setMainNavOpen(!mainNav.classList.contains("cf-main-nav--open"));
            });

            if (navBackdrop) {
                navBackdrop.addEventListener("click", function () {
                    setMainNavOpen(false);
                });
            }

            navMenu.querySelectorAll("a").forEach(function (link) {
                link.addEventListener("click", function () {
                    setMainNavOpen(false);
                });
            });

            document.addEventListener("keydown", function (event) {
                if (event.key === "Escape") {
                    setMainNavOpen(false);
                }
            });
        }
    }

    const siteHeader = document.querySelector("header.site-header");
    const formQuote = document.querySelector(".form-quote");

    if (
        siteHeader &&
        formQuote &&
        !document.body.classList.contains("editing")
    ) {
        const mobileHeaderHideMq = window.matchMedia("(max-width: 991.98px)");
        const rootEl = document.documentElement;
        let headerHideScrollTicking = false;
        let isHeaderHidden = false;

        function applyFormZoneHiddenState(hidden) {
            isHeaderHidden = hidden;
            siteHeader.classList.toggle("site-header--hidden", hidden);
            rootEl.classList.toggle("cf-form-zone-hidden", hidden);
        }

        function isFormOneThirdVisible(formRect, viewportHeight) {
            const visibleTop = Math.max(formRect.top, 0);
            const visibleBottom = Math.min(formRect.bottom, viewportHeight);
            const visibleHeight = Math.max(0, visibleBottom - visibleTop);

            return visibleHeight >= formRect.height / 3;
        }

        function syncMobileSiteHeaderVisibility() {
            if (!mobileHeaderHideMq.matches) {
                applyFormZoneHiddenState(false);
                headerHideScrollTicking = false;
                return;
            }

            const formRect = formQuote.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const aboveFormThreshold =
                viewportHeight + (isHeaderHidden ? 32 : 0);
            const isAboveForm = formRect.top >= aboveFormThreshold;
            let hidden;

            if (isAboveForm) {
                hidden = false;
            } else {
                hidden =
                    isHeaderHidden ||
                    isFormOneThirdVisible(formRect, viewportHeight);
            }

            applyFormZoneHiddenState(hidden);
            headerHideScrollTicking = false;
        }

        function onMobileSiteHeaderScroll() {
            if (!headerHideScrollTicking) {
                window.requestAnimationFrame(syncMobileSiteHeaderVisibility);
                headerHideScrollTicking = true;
            }
        }

        function resetMobileSiteHeaderVisibility() {
            syncMobileSiteHeaderVisibility();
        }

        mobileHeaderHideMq.addEventListener("change", resetMobileSiteHeaderVisibility);
        window.addEventListener("scroll", onMobileSiteHeaderScroll, {passive: true});
        window.addEventListener("resize", resetMobileSiteHeaderVisibility, {
            passive: true,
        });
        resetMobileSiteHeaderVisibility();
    }

    const layoutMainAside = document.querySelector(".layout-main-aside");
    const footerPage = document.querySelector(".footer-page");

    if (
        siteHeader &&
        (layoutMainAside || footerPage) &&
        !document.body.classList.contains("editing")
    ) {
        const mobileHeaderMq = window.matchMedia("(max-width: 991.98px)");
        let lastHeaderScrollY = window.scrollY;
        let headerScrollTicking = false;

        function isSiteHeaderOverContentZone() {
            const headerBottom = siteHeader.getBoundingClientRect().bottom;

            if (layoutMainAside) {
                const asideTop = layoutMainAside.getBoundingClientRect().top;
                if (asideTop <= headerBottom) {
                    return true;
                }
            }

            if (footerPage) {
                const footerTop = footerPage.getBoundingClientRect().top;
                if (footerTop <= headerBottom) {
                    return true;
                }
            }

            return false;
        }

        function isSiteHeaderAboveContentSections() {
            const headerBottom = siteHeader.getBoundingClientRect().bottom;

            if (layoutMainAside) {
                if (layoutMainAside.getBoundingClientRect().top <= headerBottom) {
                    return false;
                }
            }

            if (footerPage) {
                if (footerPage.getBoundingClientRect().top <= headerBottom) {
                    return false;
                }
            }

            return true;
        }

        function syncMobileSiteHeaderBackground() {
            if (!mobileHeaderMq.matches) {
                siteHeader.classList.remove("site-header--over-content");
                headerScrollTicking = false;
                return;
            }

            const scrollY = window.scrollY;
            const scrollingDown = scrollY > lastHeaderScrollY + 2;
            const scrollingUp = scrollY < lastHeaderScrollY - 2;

            if (scrollingDown && isSiteHeaderOverContentZone()) {
                siteHeader.classList.add("site-header--over-content");
            } else if (scrollingUp && isSiteHeaderAboveContentSections()) {
                siteHeader.classList.remove("site-header--over-content");
            }

            lastHeaderScrollY = scrollY;
            headerScrollTicking = false;
        }

        function onMobileHeaderScroll() {
            if (!headerScrollTicking) {
                window.requestAnimationFrame(syncMobileSiteHeaderBackground);
                headerScrollTicking = true;
            }
        }

        function resetMobileSiteHeaderBackground() {
            lastHeaderScrollY = window.scrollY;
            syncMobileSiteHeaderBackground();
        }

        mobileHeaderMq.addEventListener("change", resetMobileSiteHeaderBackground);
        window.addEventListener("scroll", onMobileHeaderScroll, {passive: true});
        window.addEventListener("resize", resetMobileSiteHeaderBackground, {
            passive: true,
        });
        resetMobileSiteHeaderBackground();
    }

    $(".countdown").each(function () {
        const cd = new CountDownManager($(this));
    });

    // prima faccio partire gli async che conterranno eventualmente anche dei '.component .swiper'
    $(".async_content_list").each(function () {
        //console.log('MAIN - faccio partire asincrono su', $(this));
        const sma = new SwiperManager($(this), true);
    });

    // poi faccio partire i '.component .swiper' non asincroni
    $(".component .swiper").each(function () {
        //console.log('MAIN - guardo il parent di component', $(this).closest('.component').parent());
        if ($(this).closest(".component").parent().hasClass("async_content_list")) {
            //console.log('MAIN - Blocco perché dentro a un async_content_list', $(this));
        } else {
            //console.log('MAIN - faccio partire sincrono su', $(this));
            const sm = new SwiperManager($(this), false);
        }
    });

    $("video.hascustomcontrols").each(function () {
        const vc = new VideoControlsManager($(this));
    });

    $('[data-role="faq"]').each(function () {
        const fm = new FAQManager($(this));
    });

    $(".modalizer").each(function () {
        const modm = new ModalizerManager($(this));
    });

    $("#map_opener").on("click", () => {
        $("#map_opener").addClass("unshow");
        $("#map_blurr").addClass("unshow");
        $(".component.map.googlemaps").removeClass("unshow");
        $(".component.map.googlemaps").addClass("showed");
        let script = document.createElement("script");
        script.src =
                "https://maps.googleapis.com/maps/api/js?key=AIzaSyBAZEkqnfy411LAXw9gHpuq5xDA0KcSpIc&libraries=places&callback=initMap";
        script.async = true;
        window.initMap = function () {
            $(".component.map.googlemaps").each(function () {
                const gmc = new GoogleMapsManager($(this));
            });
        };
        document.body.appendChild(script);
    });

    if ($(".component.map.googlemapsaside").length > 0) {
        window.gmac = new GoogleMapsAsideManager(
                $(".component.map.googlemapsaside")
                );
    }

    window.ll = new LazyLoadManager();
    window.ivm = new InvieportManager();

    setTimeout(function () {
        window.glm = new GeolocationManager();
    }, 1000);

    loadMoreArticles();

    // script per ordinamento depositivi dal più vicino in pagina deposito
    function calculateDistanceKm(lat1, lon1, lat2, lon2) {
        const earthRadius = 6371;

        const latDelta = (lat2 - lat1) * Math.PI / 180;
        const lonDelta = (lon2 - lon1) * Math.PI / 180;

        const a =
            Math.sin(latDelta / 2) ** 2 +
            Math.cos(lat1 * Math.PI / 180) *
            Math.cos(lat2 * Math.PI / 180) *
            Math.sin(lonDelta / 2) ** 2;

        return earthRadius * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    }

    function sortStoreAlternatives() {
        const container = document.querySelector('.store-alternatives');

        if (!container) {
            return;
        }

        const asyncList = container.querySelector('.async_content_list');
        const swiperEl = container.querySelector('.swiper');
        const wrapper = container.querySelector('.swiper-wrapper');

        if (!asyncList || !swiperEl || !wrapper) {
            return;
        }

        const originLat = parseFloat(asyncList.dataset.originLat);
        const originLng = parseFloat(asyncList.dataset.originLong);

        if (isNaN(originLat) || isNaN(originLng)) {
            return;
        }

        if (swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
        }

        const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'))
            .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

        slides.forEach(slide => {
            const lat = parseFloat(slide.dataset.lat);
            const lng = parseFloat(slide.dataset.lng);
            const distanceEl = slide.querySelector('.store-nearby__distance');

            let distance = Number.MAX_SAFE_INTEGER;

            if (!isNaN(lat) && !isNaN(lng)) {
                distance = calculateDistanceKm(originLat, originLng, lat, lng);
            }

            slide.dataset.distance = distance;

            if (distanceEl && distance !== Number.MAX_SAFE_INTEGER) {
                distanceEl.textContent = `${distance.toFixed(1)} km da questo deposito`;
            }
        });

        slides.sort((a, b) => {
            return parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance);
        });
        const nearestSlides = slides.slice(0, 5);

        wrapper.innerHTML = '';

        nearestSlides.forEach(slide => {
            wrapper.appendChild(slide);
        });

        new Swiper(swiperEl, {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            watchOverflow: false,
            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev')
            }
        });
    }
    setTimeout(sortStoreAlternatives, 1500);
    
    const breakpoint = 991;
    const panels = document.querySelectorAll('.section-spaces__panel');

    panels.forEach(panel => {
        const question = panel.querySelector('.section-spaces__question');
        const visual = panel.querySelector('.section-spaces__visual');
        const originalParent = visual?.parentElement;

        if (!question || !visual || !originalParent) return;

        const moveVisual = () => {
            if (window.innerWidth <= breakpoint) {
                if (visual.previousElementSibling !== question) {
                    question.insertAdjacentElement('afterend', visual);
                }
            } else {
                if (visual.parentElement !== originalParent) {
                    originalParent.appendChild(visual);
                }
            }
        };

        moveVisual();
        window.addEventListener('resize', moveVisual);
    });
});

if (document.getElementById("pre-email")) {
    document
            .getElementById("pre-email")
            .addEventListener("submit", function (event) {
                event.preventDefault(); // Previene il comportamento predefinito di invio del form

                // Recupera il valore dell'email dal primo form
                const email = document.getElementById("email").value;

                // Popola il campo email del secondo form cercando l'elemento tramite il suo name contact[email]
                document.querySelector("input[name='contact[email]']").value = email;

                // Invia i dati al tuo server (Concrete5)
                inviaDatiAlServer(email);

                // Scrolla fino al secondo form con name demo
                document.querySelector("a[name='demo']").scrollIntoView({
                    behavior: "smooth",
                });
            });
}

// Funzione per inviare i dati al server Concrete5
function inviaDatiAlServer(email) {
    // Dati che vuoi inviare
    const data = {
        spreadsheetId: "1FmNYdlntQF99zwkoRVXCGDb6R1AEym1NS2jHuHkOQq4",
        sheetName: "Partial_email",
        data: new Date().toLocaleDateString(), // Data corrente
        ora: new Date().toLocaleTimeString(), // Ora corrente
        pagina_acquisizione: window.location.href, // URL corrente
        utm_source: getUTMParam("utm_source"),
        utm_medium: getUTMParam("utm_medium"),
        utm_campaign: getUTMParam("utm_campaign"),
        email: email,

    };

    // Invia la richiesta al tuo server
    fetch('application/tools/spreadsheet-connector.php', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    })
            .then(response => response.json())
            .then(responseData => {
                if (responseData.success) {
                    console.log("Dati inviati con successo:", responseData.data);
                } else {
                    console.error("Errore dal server:", responseData.message);
                }
            })
            .catch(error => {
                console.error("Errore durante l'invio dei dati:", error);
            });
}

// Funzione per recuperare i parametri UTM dalla URL
function getUTMParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
//    console.log(urlParams.get(param));
    return urlParams.get(param) || ""; // Ritorna vuoto se non presente
}
